export default "__VITE_ASSET__cb0abb80__"